import { toast } from 'react-toastify';
import { UserSummaryType } from '../../../api/types/user/user-summary.type';
import globalUserPage from '../../../stores/global-user-page';
import appApi from '../../../api/app-api';
import { UserType } from '../../../api/types/user/user-type';
import { UserDetailsStudent } from '../../../api/types/students/user-details-student';
import { UserDetailsAdministrationResponse } from '../../../api/types/administration/user-details-administration';

export const getUserDetailsOperation = async (
  user: UserSummaryType,
  closeDialog: () => void,
  userRole: UserType | undefined,
) => {
  try {
    globalUserPage.loading = true;
    // TODO call get user details for match user
    switch (userRole ?? user.role) {
      case UserType.STUDENT:
        const studentDetailsRes = await appApi.getUserStudentDetails(user.id);
        const studentDetailsData: UserDetailsStudent =
          studentDetailsRes.data.body;
        globalUserPage.studentDetails = studentDetailsData;
        break;
      case UserType.ADMINISTRATION:
        const administrationDetailsRes =
          await appApi.getUserAdministrationDetails(user.id);
        const administrationDetailsData: UserDetailsAdministrationResponse =
          administrationDetailsRes.data.body;
        globalUserPage.administrationDetails = administrationDetailsData;
        break;
      case UserType.LECTURER:
        const lecturerDetails = await appApi.getUserLecturerDetails(user.id);
        globalUserPage.lecturerDetails = lecturerDetails.data.body;
        console.log(
          `getUserDetailsOperation  data res: ${lecturerDetails.data.body}`,
        );
        break;
    }
    globalUserPage.loading = false;
  } catch (e) {
    console.error(`getUserDetails is failed with the error:`, e);
    globalUserPage.loading = false;
    toast.error('לא ניתן לטעון את המידע המבוקש, נסה שוב בעוד מספר רגעים...');
    // Don't close dialog on error - let user see the error and try again
  }
};
